import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "flex flex-1 justify-center items-center" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "text-primary" }

import { Ref, computed, ref } from 'vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'nav-item',
  props: {
    bigimg: Boolean
},
  setup(__props) {

const props = __props;

const store = useStore()

const nav = [
    {
        number: "01",
        text: "About me",
        id: "aboutmeref"
    },
    {
        number: "02",
        text: "Skillset",
        id: "skillsetref"
    },
    {
        number: "03",
        text: "Projects",
        id: "projectsref"
    },
    {
        number: "04",
        text: "Contact",
        id: "contactref"
    }
]

// eslint-disable-next-line no-undef


const scrollIntoView = (id: string) => {
    const foundRef = store.state.navRefs.get(id)
    if (foundRef) {
        const _ref: Ref = ref(foundRef.ref)
        _ref.value.scrollIntoView({
            behavior: "smooth",
            block: _ref.value.scrollPosition
        })

    }
}
const gotoHome = () => {
    window.location.href = "/"
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(["transition-all ease-in-out duration-700 py-2 bg-white fixed w-full z-20 top-0 left-0", [__props.bigimg ? 'h-64 ' : 'h-20 border-b border-gray-300']])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: _normalizeClass(["flex object-scale-down transition-all ease-in-out duration-700 hover:cursor-pointer", [__props.bigimg ? 'h-32' : 'h-16']]),
        onClick: gotoHome,
        src: _imports_0
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["invisible xs:visible transition-all ease-in-out duration-700 absolute flex text-black gap-2 bg-white", [__props.bigimg ? 'top-6 sm:right-8' : 'top-20 xl:top-6 xl:right-8']])
      }, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(nav, (n) => {
          return _createElementVNode("div", {
            class: "mono flex gap-2 text-sm h-full text-gray-600 p-2 cursor-pointer border border-transparent hover:border-gray-300 rounded-md transition-all duration-500",
            key: n.text,
            onClick: ($event: any) => (scrollIntoView(n.id))
          }, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(n.number), 1),
            _createElementVNode("p", null, _toDisplayString(n.text), 1)
          ], 8, _hoisted_2)
        }), 64))
      ], 2)
    ])
  ], 2))
}
}

})